import React, { useRef, useState } from "react";
import BgComponent from "../Components/BgComponent";
import Logo from "../../../assets/image/logo/logo.png";
import RHFTextField from "../../../components/controls/RHFTextField";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { useForm } from "react-hook-form";
import { bool, object, string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Supabase from "../../../backend/client";
import MaskLoader from "../../../components/MaskLoader";
import { successToaster, errorToaster } from "../../../util/toaster";
import Simulation from "../../../components/Simulation";
import { useUser } from "../../../context/UserContext";
import { Bucket_Uri } from "../../../shared/constant";

const Signup = () => {
  const inputRef = useRef();
  const user = useUser();
  const [loader, setLoader] = useState(true);
  const [open, setOpen] = useState(false);
  const [broker, setBroker] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const schema = object({
    name: string().trim().required().label("Name"),
    lastname: string().trim().required().label("Last Name"),
    email: string()
      .trim()
      .email("Please enter valid email address")
      .required()
      .label("Email")
      .nullable(),
    password: string()
      .trim()
      .min(6, "Password must contain atleast 6 characters")
      .required()
      .label("Password"),
    terms: bool().oneOf([true], "Please check terms and policies."),
  });

  const [termsCheck, setTermsCheck] = useState(false);

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = "TRADEFOLIO - Signup";
    console.log("user", user);
    if (user?.user?.id) {
      navigate("/");
    }
    setValue("terms", termsCheck);
    setTimeout(() => setLoader(false), 1000);
  }, [user?.user?.id]);

  const onSubmit = async (data) => {
    setLoader(true);
    const { data: user, error } = await Supabase.from("profiles")
      .select("*")
      .eq("email", data?.email);
    if (error) {
      errorToaster(error?.message);
      reset({
        name: "",
        lastname: "",
        email: "",
        password: "",
      });
      setLoader(false);
      return;
    }

    if (user?.length > 0) {
      errorToaster(
        "User already registered. Please login using your credentials."
      );
      reset({
        name: "",
        lastname: "",
        email: "",
        password: "",
      });
      setSelectedImage(null);
      setBroker("");
      setValue("image", null);
      setLoader(false);
      return;
    }

    const fileName = `avatar_${Date.now()}.png`;
    let avatar_url = null;
    if (data?.image) {
      const { data: response, error: imgErr } = await Supabase?.storage
        ?.from("images")
        .upload(fileName, data?.image);
      avatar_url = `${Bucket_Uri}/${fileName}`;
    }

    Supabase?.auth
      ?.signUp({
        email: data?.email,
        password: data?.password,
        options: {
          data: {
            name: data?.name,
            full_name: data?.name,
            last_name: data?.lastname,
            email: data?.email,
            avatar_url,
          },
        },
      })
      .then(async (response) => {
        if (response?.error) {
          errorToaster(response?.error?.message);
          navigate("/auth/signup");
        } else {
          // Check for existing beta signup
          const { data: betaSignup, error: betaError } = await Supabase
            .from("beta_signups")
            .select("*")
            .eq("email", data?.email)
            .single();

          if (betaSignup && !betaError) {
            // Update the user's profile with beta data
            const { error: updateError } = await Supabase
              .from("profiles")
              .update({
                beta_user: true,
                beta_signup_id: betaSignup.id,
                alpaca_account_id: betaSignup.alpaca_account_id
              })
              .eq("email", data?.email);

            if (updateError) {
              console.error("Failed to link beta signup:", updateError);
            }
          }

          successToaster(
            "Account Created successfully. Please check your email to verify your account!"
          );
          navigate("/");
        }
      })
      .catch((error) => {
        errorToaster("Something went wrong.");
      })
      .finally(() => {
        reset({
          name: "",
          lastname: "",
          email: "",
          password: "",
        });
        setSelectedImage(null);
        setBroker("");
        setValue("image", null);
        setLoader(false);
      });
  };

  const handleTermsCheck = (e) => {
    setValue("terms", !termsCheck);
    setTermsCheck(!termsCheck);
  };

  const isTermsError = errors?.terms;

  const handleChange = (e) => {
    // get the files
    let files = e.target.files;

    if (e?.target?.files?.length) {
      setValue("image", e?.target?.files[0]);
    }

    // Process each file
    var allFiles = [];
    for (var i = 0; i < files.length; i++) {
      let file = files[i];

      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        let fileInfo = {
          name: file.name,
          type: file.type,
          size: Math.round(file.size / 1000) + " kB",
          base64: reader.result,
          file: file,
        };

        // Push it to the state
        allFiles.push(fileInfo);
        console.log("allFiles", allFiles);
        setSelectedImage(allFiles[0].base64);
        // If all files have been proceed
        // if (allFiles.length == files.length) {
        //   // Apply Callback function
        //   if (this.props.multiple) this.props.onDone(allFiles);
        //   else this.props.onDone(allFiles[0]);
        // }
      }; // reader.onload
    } // for
  };

  return loader ? (
    <MaskLoader />
  ) : (
    <>
      <div className="flex flex-col min-h-[100vh] w-full">
        <div className="lg:hidden xs:mb-0">
          <IconButton
            onClick={() => navigate(-1)}
            sx={{
              margin: 3,
              color: "#000",
              position: "absolute",
              zIndex: 999,
            }}>
            <ArrowBackIcon />
          </IconButton>
        </div>
        <div className="flex flex-row w-full h-[100vh] flex-1">
          <div className="lg:flex flex-[0.40] xs:hidden">
            <BgComponent bgImg="bg-signup-bg">
              <p className="text-white text-[50px] font-bold absolute bottom-40 left-4">
                Putting the Power <br />
                Back Into Your Hands.
              </p>
            </BgComponent>
          </div>
          <div className="flex md:flex-[0.60] xs:flex-[0.80] flex-col lg:max-w-[550px] mx-auto xs:pt-[80px] md:pt-[40px] justify-center">
            <a href="/">
              <img src={Logo} className="relative xs:w-[120px] md:w-[170px]" />
            </a>
            <div className="xs:py-4 md:py-12 xl:px-0">
              <p className="xs:text-[22px] md:text-[35px] font-bold font-sans">
                Create Your Account
              </p>
              <p className="text-[#7A86A1] text-xs md:text-sm">
                Sign up using your email address
              </p>
              <div className="grid grid-cols-1 lg:grid-cols-2 xs:gap-[10px] md:gap-5 xs:pt-[15px] md:pt-10">
                <div className="flex flex-row gap-[10px] items-center">
                  <div className="xs:w-[50px] md:w-[100px] xs:h-[50px] md:h-[100px] border border-solid border-[#7a86a1] rounded-full flex items-center justify-center">
                    {selectedImage ? (
                      <img
                        src={selectedImage}
                        className="w-[95%] h-[95%] rounded-full"
                      />
                    ) : (
                      <div className="w-[95%] h-[95%] border border-dashed border-[#7a86a1] rounded-full"></div>
                    )}
                  </div>
                  {selectedImage ? (
                    <button
                      className="border border-solid border-[#7a86a1] rounded-lg xs:p-[5px] xs:text-[13px] md:text-[15px] md:p-[10px] text-[#7a86a1] xs:h-[30px] md:h-[50px]"
                      onClick={() => {
                        setSelectedImage(null);
                        setValue("image", null);
                      }}>
                      Remove Image
                    </button>
                  ) : (
                    <button
                      className="border border-solid border-[#7a86a1] rounded-lg xs:p-[5px] xs:text-[13px] md:text-[15px] md:p-[10px] text-[#7a86a1] xs:h-[30px] md:h-[50px]"
                      onClick={() => {
                        if (inputRef.current) {
                          inputRef.current.click();
                        }
                      }}>
                      Add Image
                    </button>
                  )}

                  <input
                    type="file"
                    className="opacity-0 hidden"
                    ref={inputRef}
                    accept="image/*"
                    multiple={false}
                    onChange={(e) => {
                      handleChange(e);
                      //setSelectedImage(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-1 xs:gap-[10px] md:gap-5 xs:pt-[15px]">
                <select className="px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg ">
                  <option value={"Free"}>Free Plan</option>
                  <option value={"Plus"} disabled>
                    Plus Plan
                  </option>
                  <option value={"Premium"} disabled>
                    Premium Plan
                  </option>
                </select>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 xs:gap-[10px] md:gap-5 xs:pt-[15px]">
                <div>
                  <RHFTextField
                    name="name"
                    id="name"
                    type="text"
                    fullWidth
                    placeholder="Name"
                    className="px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                  />
                </div>
                <div>
                  <RHFTextField
                    name="lastname"
                    id="lastname"
                    fullWidth
                    placeholder="Last Name"
                    className="px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                  />
                </div>
                <div>
                  <RHFTextField
                    name="email"
                    id="email"
                    type="email"
                    fullWidth
                    placeholder="Your email"
                    className="px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                  />
                </div>
                <div>
                  <RHFTextField
                    name="password"
                    id="password"
                    type="password"
                    fullWidth
                    placeholder="Password 7+ Characters"
                    className="px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                  />
                </div>
                <div>
                  <button
                    onClick={() => setOpen(true)}
                    className="w-full bg-[#909090] text-white  font-semibold xs:p-1 md:p-3 rounded-lg xs:text-[12] md:text-[14px]">
                    {broker !== "" ? broker : `Connect Broker Account`}
                  </button>
                </div>
                <div></div>
                <div className="">
                  <div className="flex">
                    <input
                      type="checkbox"
                      name="terms"
                      id="terms"
                      onClick={handleTermsCheck}
                      checked={termsCheck}
                    />
                    <label
                      htmlFor="terms"
                      className="text-[#7A86A1] xs:text-[12px] md:text-[14px] px-2">
                      I accept the{" "}
                      <span className="text-[#0061FC] font-semibold xs:text-[12px] md:text-[14px]">
                        Terms and Conditions
                      </span>
                    </label>
                  </div>
                  {isTermsError ? (
                    <p className="text-[10px] pt-[2px] text-[red]">
                      Please check terms and policies.
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div></div>
                <div>
                  <button
                    onClick={handleSubmit(onSubmit)}
                    className="w-full bg-[#0061FC] text-white  font-semibold xs:p-1 md:p-3 rounded-lg xs:text-[12] md:text-[14px]">
                    Create Account
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between py-[20px] md:px-20 xs:px-4  text-[#000000] w-full border-t-[1px]">
          <div className="opacity-50 text-[10px] font-sans">
            &copy;2023 TRADEFOLIO Inc. All Rights Reserved
          </div>
          <div className="opacity-50 text-[10px] font-sans  ">
            <Link to="/privacy">
              <u>Privacy Policy</u>
            </Link>{" "}
            /{" "}
            <Link to="/terms">
              <u>User agreement</u>
            </Link>
          </div>
        </div>
      </div>
      {open ? (
        <Simulation
          open={open}
          handleClose={() => setOpen(false)}
          setBroker={setBroker}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Signup;
